import {Pipe, PipeTransform} from "@angular/core"
import { EditArt } from "../_interfaces/EditArt";
import { TicketEditService } from "../_provider/ticket-edit.service";

    @Pipe({
        name: "TreeViewChildren",
        pure: true
    })
    export class TreeViewChildren implements PipeTransform{
    
        constructor(
            private ticketEditSrv: TicketEditService
        ){}

        /**
         * Gibt alle Child elemente einer Ticketart zurück
         * @param {EditArt} art Ticketart als EditartObject 
         * @param args args[0] == true alle werden zurückgegebe, die keinen parent haben
         * @returns {EditArt[]}
         */
        transform(art: EditArt | EditArt[], ...args: any[]) {

            if(args[1]) return

            if(!args[0]) return this.ticketEditSrv.ticketArts.filter(ta => 
                ta.parentId == (art as EditArt).id
            )
            return this.ticketEditSrv.ticketArts.filter(ta => 
                ta.parentId < 1
            )
        }
    }

    @Pipe({
        name: "TreeViewSearch",
        pure: true
    })
    export class TreeViewSearch implements PipeTransform{

        constructor(private ticketEditSrv: TicketEditService){}

        /**
         * Gibt alle TicketArten nach filtern eines Suchtextes zurück
         * @param value 
         * @param args args[0] Suchtext 
         * @returns 
         */
        transform(value: any, ...args: any[]) {
            return transformTreeViewSearch(value, args[0])
        }
    }

    export function transformTreeViewSearch(value: EditArt[], ...args: any[]){
        const searchText = args[0] as string
        return value.filter(ta => 
            ta.description.toLowerCase().includes(searchText.toLowerCase())   
        )
    }
